import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSuppliers(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/suppliers', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createSupplier(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/suppliers', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateSupplier(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/suppliers/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}